"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    male: 'male',
    female: 'female',
};
